import { computed, getCurrentInstance } from 'vue';

/**
 * Resolve the enclosing <b-field>'s status type (e.g. 'is-danger') from a custom
 * form-control wrapper.
 *
 * Custom wrappers (autocompletes, date pickers…) sit between a <b-field> and its
 * real <input>, which breaks Buefy's parent-walk that copies the field's is-danger
 * status onto the input — so the field message turns red but the control keeps a
 * neutral border. A wrapper calls this and forwards the returned type to its inner
 * Buefy control (or inner field), keeping error styling consistent with plain
 * fields across every form. Returns undefined when not inside a <b-field>.
 *
 * @returns {import('vue').ComputedRef<string|object|undefined>}
 */
export function useFieldStatus() {
    const instance = getCurrentInstance();

    return computed(() => {
        let vm = instance?.parent;
        for (let i = 0; i < 4 && vm; i++) {
            if (vm.proxy?.$data?._isField) {
                return vm.proxy.newType;
            }
            vm = vm.parent;
        }
        return undefined;
    });
}
